const classMap = {
  userSettings: 'js-user-settings',
  button: 'js-btn-user-settings',
  close: 'js-user-settings-close',
  content: 'js-user-settings-content',
  premiumSubscribe: 'js-premium-subscribe',
  initials: 'js-user-initials',
  name: 'js-user-name',
  jsMenu: 'js-menu',
}

const getInitials = (name) => {
  if (!name) return 'FF'
  const nameSplited = name.split(' ')
  let firstLetter = ''
  let secondyLetter = ''
  if (nameSplited.length > 1) {
    firstLetter = nameSplited[0].charAt(0).toLocaleUpperCase()
    secondyLetter = nameSplited[1].charAt(0).toLocaleUpperCase()
  } else {
    firstLetter = nameSplited[0].charAt(0).toLocaleUpperCase()
    secondyLetter = nameSplited[0].charAt(1).toLocaleUpperCase()
  }
  return `${firstLetter}${secondyLetter}`
}
const getFirstLastName = (name) => {
  if (!name) return 'Boas vindas'
  const nameSplited = name.split(' ')
  const firstName = nameSplited[0]
  const lastName = nameSplited[nameSplited.length - 1]
  return `${firstName.charAt(0).toLocaleUpperCase()}${firstName.slice(1)} ${lastName.charAt(0).toLocaleUpperCase()}${lastName.slice(1)}`
}

export default class UserSettings {
  constructor() {
    this.userSettings = document.querySelector(`.${classMap.userSettings}`)
    this.menu = document.querySelector(`.${classMap.jsMenu}`)
    this.buttons = document.querySelectorAll(`.${classMap.button}`)
    this.content = document.querySelector(`.${classMap.content}`)
    this.premiumSubscribe = document.querySelector(`.${classMap.premiumSubscribe}`)
    this.initials = document.querySelector(`.${classMap.initials}`)
    this.nameArr = document.querySelectorAll(`.${classMap.name}`)
  }

  mount() {
    if (!document.querySelector(`.${classMap.userSettings}`)) return
    document.addEventListener('click', this.onHandlerUserSettings.bind(this));
    document.addEventListener('click', this.onHandlerClose.bind(this))

    try {
      fetch('/account/api/me')
        .then(x => x.json())
        .then(data => {
          if (data.success) {
            this.nameArr.forEach((el) => {
              el.innerHTML = getFirstLastName(data.user?.name);
            });
            this.initials.innerHTML = getInitials(data.user?.name);
            this.menu.classList.add('is-logged-in')
            this.userSettings.querySelectorAll('[data-href]').forEach((item) => {
              item.setAttribute('href', item.dataset.href)
            })

            this.menu.classList.add(data.user?.isPremium ? 'is-premium' : 'is-not-premium')
          } else {
            this.menu.classList.add('is-not-logged-in')
            this.menu.classList.add('is-not-premium')
          }
        }).catch(() => {
          this.menu.classList.add('is-not-logged-in')
          this.menu.classList.add('is-not-premium')
        })
    } catch (err) {
      this.menu.classList.add('is-not-logged-in')
      this.menu.classList.add('is-not-premium')
    }
  }

  /**
   * used only on mobile
   */
  onHandlerClose(event) {
    const clickedClose = event.target.closest(`.${classMap.close}`)
    if (!clickedClose) return

    this.closeUserSettings()
  }

  closeUserSettings(){
    this.userSettings.classList.remove('is-open')

    this.content.setAttribute('aria-hidden', true)

    this.buttons.forEach((button) => {
      button.setAttribute('aria-expanded', false);
    });
  }

  onHandlerUserSettings(e){
    const clickedUserSettings= e.target.closest(`.${classMap.userSettings}`)
    // click outside of user settings
    if (!clickedUserSettings) {
      this.closeUserSettings()
      return
    }

    const clickedButton= e.target.closest(`.${classMap.button}`)
    if (clickedButton) {
      this.userSettings.classList.toggle('is-open')

      const isExpanded = this.content.getAttribute('aria-hidden') === 'true';
      this.content.setAttribute('aria-hidden', !isExpanded);

      this.buttons.forEach((button) => {
        button.setAttribute('aria-expanded', isExpanded);
      });

      return
    }
  }
}
